import { render, staticRenderFns } from "./Devices.html?vue&type=template&id=2f972f23&"
import script from "./Devices.js?vue&type=script&lang=js&"
export * from "./Devices.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports